import React from "react";
import SegmentButton2 from "../AdminReports/SegmentButton2";
import DeletedProfile from "../AdminReports/DeletedProfile";
import DeletedRecruter from "./DeletedRecruter";
import DeletedClient from "./DeletedClient";

const DeleteSegment = () => {
  const [activeButton, setActiveButton] = React.useState("recruiter");
  const buttonsConfig = [
    { key: "recruiter", label: "Recruiters" },
    { key: "client", label: "Clients" },
  ];
  return (
    <div>
      <SegmentButton2
        buttonsConfig={buttonsConfig}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />

      {activeButton === "recruiter" && <DeletedRecruter />}
      {activeButton === "client" && <DeletedClient />}
    </div>
  );
};

export default DeleteSegment;
